var _path, _path2, _path3, _path4, _path5, _path6, _path7, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFolder(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 37,
    viewBox: "0 0 40 37",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.6481 6.98227L11.9607 2.29492C11.7816 2.67375 11.689 3.08763 11.6895 3.50665V8.09426H17.7561L16.6481 6.98227Z",
    fill: "url(#paint0_linear_3050_4516)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.7655 3.80552L11.868 2.15497C11.6246 1.70568 11.2645 1.33033 10.8257 1.06846C10.387 0.806593 9.88567 0.667901 9.37469 0.666992L2.84133 0.666992C2.08776 0.666992 1.36506 0.966346 0.832206 1.4992C0.299353 2.03205 0 2.75475 0 3.50832L0 33.6519C0 34.0251 0.0734931 34.3945 0.216283 34.7393C0.359073 35.084 0.568364 35.3972 0.832206 35.661C1.09605 35.9249 1.40927 36.1342 1.754 36.277C2.09872 36.4198 2.4682 36.4933 2.84133 36.4933H37.1587C37.5318 36.4933 37.9013 36.4198 38.246 36.277C38.5907 36.1342 38.9039 35.9249 39.1678 35.661C39.4316 35.3972 39.6409 35.084 39.7837 34.7393C39.9265 34.3945 40 34.0251 40 33.6519V8.32033C40 7.9472 39.9265 7.57772 39.7837 7.233C39.6409 6.88827 39.4316 6.57505 39.1678 6.3112C38.9039 6.04736 38.5907 5.83807 38.246 5.69528C37.9013 5.55249 37.5318 5.479 37.1587 5.479H15.5819C15.0052 5.48 14.4389 5.32498 13.9431 5.03037C13.4473 4.73577 13.0404 4.31254 12.7655 3.80552Z",
    fill: "#FFB949"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M2.84133 36.4978H37.1587C37.5318 36.4978 37.9013 36.4243 38.246 36.2815C38.5907 36.1387 38.9039 35.9294 39.1678 35.6656C39.4316 35.4017 39.6409 35.0885 39.7837 34.7438C39.9265 34.399 40 34.0296 40 33.6564V12.2921L34.077 6.36811C33.8667 6.11226 33.6069 5.90157 33.3132 5.74869C33.0194 5.59581 32.6978 5.50392 32.3676 5.47852H26.3219C25.913 5.51068 25.5185 5.6446 25.1745 5.86807C24.8305 6.09154 24.5479 6.39749 24.3522 6.75806L23.5783 8.18721C23.3408 8.62605 22.9891 8.99255 22.5604 9.24798C22.1317 9.5034 21.6419 9.63826 21.1429 9.63828H2.46036C1.80783 9.63828 1.18203 9.8975 0.720625 10.3589C0.259218 10.8203 2.8007e-06 11.4461 2.8007e-06 12.0986V33.6524C-0.000521544 34.0259 0.0725847 34.3958 0.21514 34.741C0.357695 35.0862 0.566903 35.3999 0.830797 35.6641C1.09469 35.9284 1.40809 36.1381 1.75308 36.2811C2.09807 36.4241 2.46787 36.4978 2.84133 36.4978Z",
    fill: "url(#paint1_linear_3050_4516)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M33.331 13.258V5.479H15.5789C15.0027 5.47935 14.4371 5.32404 13.9419 5.02947C13.4467 4.7349 13.0402 4.31202 12.7655 3.80552L11.868 2.15497C11.6246 1.70568 11.2645 1.33033 10.8257 1.06846C10.387 0.806593 9.88567 0.667901 9.37469 0.666992L2.84133 0.666992C2.08776 0.666992 1.36506 0.966346 0.832206 1.4992C0.299353 2.03205 0 2.75475 0 3.50832L0 13.258H33.331Z",
    fill: "url(#paint2_linear_3050_4516)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M35.1702 36.4921H2.80064C2.35416 36.4921 1.92597 36.3147 1.61026 35.999C1.29455 35.6833 1.11719 35.2551 1.11719 34.8087V9.77625C1.11706 9.55509 1.1605 9.33607 1.24505 9.13171C1.32959 8.92735 1.45357 8.74165 1.60991 8.58522C1.76624 8.42879 1.95187 8.30471 2.15618 8.22004C2.36049 8.13538 2.57948 8.0918 2.80064 8.0918H35.1702C35.6167 8.0918 36.0449 8.26916 36.3606 8.58487C36.6763 8.90058 36.8537 9.32877 36.8537 9.77525V34.8077C36.8538 35.0288 36.8104 35.2478 36.7258 35.4522C36.6413 35.6566 36.5173 35.8423 36.361 35.9987C36.2046 36.1551 36.019 36.2792 35.8147 36.3639C35.6104 36.4485 35.3914 36.4921 35.1702 36.4921Z",
    fill: "url(#paint3_linear_3050_4516)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M23.5773 8.18739L24.3522 6.75825C24.5632 6.36849 24.8757 6.04299 25.2564 5.81617C25.6372 5.58936 26.0722 5.46966 26.5154 5.46973H32.1761C32.8286 5.46973 33.4544 5.72894 33.9159 6.19035C34.3773 6.65176 34.6365 7.27756 34.6365 7.93008V33.9698C34.6362 34.3011 34.7012 34.6292 34.8278 34.9354C34.9544 35.2415 35.14 35.5198 35.3741 35.7542C35.6083 35.9886 35.8863 36.1746 36.1923 36.3015C36.4983 36.4284 36.8264 36.4938 37.1577 36.494H2.46036C2.13706 36.4941 1.8169 36.4305 1.5182 36.3067C1.21951 36.183 0.948143 36.0016 0.719625 35.7729C0.491108 35.5442 0.309926 35.2727 0.186445 34.9739C0.0629645 34.6751 -0.00039152 34.3549 1.82032e-06 34.0316V12.0968C1.82032e-06 11.4443 0.259217 10.8185 0.720624 10.3571C1.18203 9.89569 1.80783 9.63647 2.46036 9.63647H21.1429C21.6416 9.63657 22.131 9.50198 22.5595 9.24692C22.988 8.99185 23.3397 8.62579 23.5773 8.18739Z",
    fill: "url(#paint4_linear_3050_4516)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M0 27.8174V34.0336C0 34.6861 0.259215 35.3119 0.720622 35.7733C1.18203 36.2347 1.80783 36.4939 2.46036 36.4939H37.1577C36.8265 36.4939 36.4985 36.4287 36.1925 36.302C35.8865 36.1752 35.6084 35.9894 35.3742 35.7552C35.14 35.521 34.9542 35.243 34.8275 34.937C34.7007 34.6309 34.6355 34.303 34.6355 33.9718V27.8184L0 27.8174Z",
    fill: "url(#paint5_linear_3050_4516)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_3050_4516",
    x1: 14.8866,
    y1: 8.26244,
    x2: 8.41135,
    y2: 1.16828,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E58200",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.04,
    stopColor: "#E27F04",
    stopOpacity: 0.039
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.467,
    stopColor: "#C15D2F",
    stopOpacity: 0.467
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.802,
    stopColor: "#AD4949",
    stopOpacity: 0.8
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A64153"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_3050_4516",
    x1: 31.28,
    y1: 34.8537,
    x2: 13.9409,
    y2: 6.002,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E4003D",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.107,
    stopColor: "#D21243",
    stopOpacity: 0.106
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.266,
    stopColor: "#BF274A",
    stopOpacity: 0.267
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.446,
    stopColor: "#B1364F",
    stopOpacity: 0.447
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.661,
    stopColor: "#A83E52",
    stopOpacity: 0.663
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A64153"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_3050_4516",
    x1: 16.6655,
    y1: 5.1368,
    x2: 16.6655,
    y2: 13.0691,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E4003D",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.107,
    stopColor: "#D21243",
    stopOpacity: 0.106
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.266,
    stopColor: "#BF274A",
    stopOpacity: 0.267
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.446,
    stopColor: "#B1364F",
    stopOpacity: 0.447
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.661,
    stopColor: "#FFB949",
    stopOpacity: 0.663
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFB949"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_3050_4516",
    x1: 14.0895,
    y1: 13.4595,
    x2: 24.582,
    y2: 43.4,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFFCF8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.188,
    stopColor: "#FAF8F6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.404,
    stopColor: "#ECEEF2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.635,
    stopColor: "#D5DCEA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.875,
    stopColor: "#B5C4DF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A1B5D8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_3050_4516",
    x1: 12.4107,
    y1: 16.049,
    x2: 34.5085,
    y2: 47.7592,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFB949"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.326,
    stopColor: "#FFB949"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.532,
    stopColor: "#FFB949"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.705,
    stopColor: "#FFB949"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.859,
    stopColor: "#FFB949"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFB949"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_3050_4516",
    x1: 18.5788,
    y1: 33.327,
    x2: 18.5788,
    y2: 38.2466,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E4003D",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.202,
    stopColor: "#D01544",
    stopOpacity: 0.204
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.499,
    stopColor: "#B92D4C",
    stopOpacity: 0.498
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.773,
    stopColor: "#AB3C51",
    stopOpacity: 0.773
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A64153"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFolder);
export default __webpack_public_path__ + "static/media/folder.b741458d002e6c9b585f99c06a967468.svg";
export { ForwardRef as ReactComponent };